import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { usePricesStore } from '@/infrastructure/prices/usePricesStore';
import { useAccommodationContext } from '@/react-pages/Prices/AccommodationContext';
import { useDependencies } from '@/scopes/common/infrastructure/dependencies';
import * as React from 'react';
import { useAccommodationAvailability } from '@/domain/prices/availability/hooks';

export const usePromotedPriceQueryKey = () => {
  const { filterSelection } = usePricesStore();
  const selection = (({ DepartureDate: _, ...object }) => object)(filterSelection);
  return React.useMemo(() => ['promoted-price', JSON.stringify(selection)], [selection]);
};

export function usePromotedPrice() {
  const { promotedPriceAPIClient } = useDependencies();
  const { isAccommodationAvailable } = useAccommodationAvailability();
  const { filterSelection } = usePricesStore();
  const { contextItemId, accoId, promotedPriceId } = useAccommodationContext();

  const { data, isLoading, isError, isFetching } = useQuery({
    queryKey: usePromotedPriceQueryKey(),
    queryFn: async () =>
      promotedPriceAPIClient.getPromotedPrice({
        contextItemId,
        accoId,
        promotedPriceId,
        filterSelection,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    retry: false,
    enabled: isAccommodationAvailable,
  });

  return {
    data,
    isLoading,
    isError,
    isFetching,
    participants: filterSelection?.Participants,
  };
}
